import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputBase,
  OutlinedInput,
  styled,
  Typography,
} from "@mui/material";
import SimpleBar from "simplebar-react";
import logo from "../../../../assets/svg/fedex.svg";
import logo2 from "../../../../assets/svg/ups.svg";
import selected from "../../../../assets/svg/selected.svg";
import arrow_check from "../../../../assets/svg/arrow_check.svg";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  // borderRadius: "12px",
  // backgroundColor: "#FAFAFA",
  // "&:hover": {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
  marginLeft: 0,
  // width: "230px",
  height: "35px",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(1),
    // width: "auto",
  },
  border: "1px solid rgba(229, 229, 232, 1)",
  borderRadius: "4px",
  marginTop: "12px",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(0)})`,
    // transition: theme.transitions.create("width"),
    width: "230px",
    backgroundColor: "white",
    // [theme.breakpoints.up("sm")]: {
    //   width: "12ch",
    //   "&:focus": {
    //     width: "20ch",
    //   },
    // },
  },
}));

const CarrierCard = ({ location, isSelected, onSelect }) => {
  return (
    <Card
      onClick={() => onSelect(location.id)}
      sx={{
        border: isSelected ? "2px solid green" : "1px solid #e0e0e0",
        borderRadius: "4px",
        cursor: "pointer",
        position: "relative",
        "&:hover": {
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <CardContent sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={location.img}
          alt={location.name}
          width="32px"
          height="32px"
        />
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "12px",
            marginLeft: "8px",
            color: "background: rgba(28, 38, 48, 1)",
          }}
        >
          {location.name}
        </Typography>
      </CardContent>
      {isSelected && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: -2,
            color: "green",
          }}
        >
          <img src={selected} alt="select" />
          <img
            src={arrow_check}
            alt="select"
            style={{
              position: "absolute",
              top: 5,
              right: 5,
            }}
          />
        </Box>
      )}
    </Card>
  );
};

export default function ShipmentSetting() {
  const [selectedCarrierId, setSelectedCarrierId] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [checked, setChecked] = useState(false);
  const [checkedAmonut, setCheckedAmount] = useState(false);

  const carrier = [
    {
      id: 1,
      name: "FedEx",
      img: logo,
    },
    {
      id: 2,
      name: "UPS",
      img: logo2,
    },
    {
      id: 3,
      name: "MailCarib",
      img: logo,
    },
    {
      id: 4,
      name: "MailCarib",
      img: logo2,
    },
    {
      id: 5,
      name: "FedEx",
      img: logo,
    },
    {
      id: 6,
      name: "UPS",
      img: logo2,
    },
    {
      id: 7,
      name: "UPS",
      img: logo2,
    },
  ];

  const handleSelectCarrier = (id) => {
    setSelectedCarrierId(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((carrierId) => carrierId !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const filteredCarriers = carrier.filter((c) =>
    c.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>
      <SimpleBar
        forceVisible="x"
        autoHide={true}
        style={{
          overflowX: "auto",
          maxHeight: "calc(100vh - 280px)",
          minHeight: "calc(100vh - 280px)",
        }}
        className="custom-scrollbar"
      >
        <Box
          sx={{
            width: "50%",
            //   margin: "0 auto",
            padding: "20px",
            backgroundColor: "white",
          }}
        >
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            Shipping Method
          </Typography>
          {/* <Box>
          <Search>
            <StyledInputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Search>
        </Box> */}

          <Box sx={{ marginTop: 2 }}>
            <Grid container spacing={2}>
              {filteredCarriers.map((location) => (
                <Grid item xs={12} sm={12} md={4} key={location.id}>
                  <CarrierCard
                    location={location}
                    isSelected={selectedCarrierId.includes(location.id)}
                    onSelect={handleSelectCarrier}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            width: "50%",
            padding: "12px 13px",
            backgroundColor:
              checked === true ? "rgba(238, 235, 246, 1)" : "#fff",
            border:
              checked === true
                ? "1px solid rgba(72, 26, 163, 1)"
                : "1px solid rgba(229, 229, 232, 1)",
            borderRadius: "6px",
          }}
        >
          <Box>
            <FormControlLabel
              label="Add Free Shipping"
              control={
                <Checkbox
                  size="small"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
          </Box>
        </Box>
        <Box
          sx={{
            width: "50%",
            marginTop: "24px",
          }}
        >
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
              Minimum amount to get free shipping
            </Typography>
          </Box>
          <Box>
            <FormControl fullWidth sx={{ mt: "8px" }}>
              <OutlinedInput
                id="outlined-adornment-amount"
                sx={{
                  height: "35px",
                }}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
              />
            </FormControl>
          </Box>
          <Box>
            <FormControlLabel
              label="No minimum amount"
              control={
                <Checkbox
                  size="small"
                  checked={checkedAmonut}
                  onChange={(e) => setCheckedAmount(e.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
          </Box>
          <Box sx={{ marginTop: "35px" }}>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    backgroundColor: "black",
                    width: "5px",
                    height: "5px",
                    borderRadius: "100%",
                    mr: 1,
                  }}
                ></Box>
                <Box>
                  <Box sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Seller Location based on profile
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    backgroundColor: "black",
                    width: "5px",
                    height: "5px",
                    borderRadius: "100%",
                    mr: 1,
                  }}
                ></Box>
                <Box>
                  <Box sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Dropdown (different price based on the city)
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </SimpleBar>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          borderTop: "1px solid #e5e7eb",
          paddingTop: "20px",
        }}
      >
        <Button
          sx={{
            width: "153px",
            height: "35px",
            border: "1px solid rgba(229, 229, 232, 1)",
            mr: 1,
            color: "black",
            backgroundColor: "rgba(255, 255, 255, 1)",
          }}
        >
          Cancel
        </Button>
        <Button
          sx={{
            width: "153px",
            height: "35px",
            backgroundColor: "rgba(94, 23, 235, 1)",
            color: "#fff",
            ":hover": {
              backgroundColor: "rgba(94, 23, 235, 1)",
            },
          }}
        >
          Save
        </Button>
      </Box>
    </>
  );
}
